import { DKGqlClient } from './Client';

export const hpGqlClient = DKGqlClient();
